// extracted by mini-css-extract-plugin
export default {"section":"section---yPeGc","active":"active---ax5vs"};